























































import { Component,Model, Vue } from "vue-property-decorator";
import { BPopover } from "bootstrap-vue";
import { GapDateFilter } from "@/store/modules/types";
import DatePicker from "vuejs-datepicker";
import { GapTransportationCoordinationReportFilter } from "@/store/modules/types";

@Component({
  components: {
    BPopover,
    DatePicker,
  },
})
export default class ReferenceDateFilter extends Vue {
 @Model("change") readonly filter!: GapTransportationCoordinationReportFilter;
  id = "reference-date-filter-popover";
  target = "reference-date-filter-target";
  //filter = this.defaultFilter();
  defaultFilter(): GapDateFilter {
    return {
      from: null,
      to: null,
    };
  }
  search() {
    //this.filter.referenceDate = { ...this.filter };
    this.$emit('refresh')
    this.close();
  }
  clear() {
    this.filter.referenceDate = this.defaultFilter();
    this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    /*const { referenceDate } = this.filter;
    this.filter = JSON.parse(JSON.stringify(referenceDate));*/
  }
}
